import {es_translations} from './es_translations'

export const translations = {
    'es': es_translations
}